import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { BriefingStepItem } from '@/shared/briefing'
import type { EmcBriefingStep } from '../../utils/emcLegislationBriefing'
import { EMC_BRIEFING_ID_PREFIX } from './constants'
import { toV2EmcBriefingStep } from './toV2EmcBriefingStep'

export function V2EmcLegislationBriefingStepShell({
  step,
  index,
  actions,
  children,
}: {
  step: EmcBriefingStep
  index: number
  actions?: ReactNode
  children?: ReactNode
}) {
  const { t } = useTranslation('common')

  return (
    <BriefingStepItem
      idPrefix={EMC_BRIEFING_ID_PREFIX}
      index={index}
      step={toV2EmcBriefingStep(step, t)}
      actions={actions}
    >
      {children}
    </BriefingStepItem>
  )
}
